import { useSectionInfoRequiredToggle } from "@/components/ActiveProjects/shared/hooks/useSectionInfoRequiredToggle";
import type { UseAllergensInfoRequiredToggleArgs } from "./useAllergensInfoRequiredToggle.types";

export function useAllergensInfoRequiredToggle(args: UseAllergensInfoRequiredToggleArgs) {
  return useSectionInfoRequiredToggle({
    enabled: args.enabled,
    signatureKey: String(args.productId),
    vendorGroupIndex: args.activeVendorTab || 0,
    vendorVersionIndex: args.activeVendorVersionIndex ?? 0,
    sources: [args.selectedActiveProject, args.activeProjectsProductInfo],
    setSources: [args.setSelectedActiveProject, args.setActiveProjectsProductInfo],
    vendorAssessmentId: args.vendorAssessmentId,
    tabName: "allergen",
    editableFieldKey: "allergenSectionEditable",
    defaultEditableWhenMissing: false,
    value: args.value,
    setValue: args.setValue,
    setGlobalLoading: args.setGlobalLoading,
    onDisabled: args.onDisabled,
    clearTabValidation: args.clearTabValidation,
    clearTabValidationIds: ["allergens"],
  });
}

